import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'
import { ErrorMessages } from '../types'

export const schema = (texts: ErrorMessages) =>
  z.object({
    BrancheId: z.string().min(1, texts.normal_assert_text),
    Title: z.string().optional(),
    FirstName: z.string().min(1, texts.normal_assert_text).max(100),
    Surname: z.string().min(1, texts.normal_assert_text).max(100),
    Company: z.string().min(3, texts.company_assert_text).max(100),
    TradeName: z.string().optional(),
    Address1: z
      .string()
      .min(3, texts.company_assert_text)
      .max(35, texts.max_length_error + ': 35')
      .regex(/^[^_+*]+$/, texts.invalid_character_error)
      .refine((val) => val.trim().length > 0, {
        message: texts.empty_spaces_error
      })
      // Reject placeholder addresses made only of symbols and spaces, e.g. "---" or "- -"
      .refine((val) => /[^\s_\-+*]/.test(val), {
        message: texts.invalid_character_error
      }),
    Postcode: z.string().min(3, texts.company_assert_text).max(10),
    Town: z.string().min(3, texts.company_assert_text).max(100),
    Country: z.string().min(1, texts.normal_assert_text).max(100),
    StateId: z.string().optional(),
    Telephone: z.string().min(3, texts.company_assert_text).max(100),
    Mobile: z.string().optional(),
    Email: z.string().min(1, texts.normal_assert_text).email(texts.email_assert_text),
    agb_accepted: z.boolean().refine((val) => val === true, {
      message: texts.normal_assert_text
    }),
    newsletter: z.boolean()
  })

export const schemaResolver = (texts: ErrorMessages) => zodResolver(schema(texts))
